import { usePrefetch } from '@blog/services';
import { TBlogCard } from '@blog/types/blog';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import { Typography } from '@mui/material';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

export interface IBlogCardProps {
    categories: string[];
    author: TBlogCard['author'];
    date: string | Date;
    title: TBlogCard['title'];
    summary: TBlogCard['excerpt'];
    slug: TBlogCard['slug'];
    image?: TBlogCard['image'];
}

export const BlogCard = ({ author, date, title, summary, slug, image }: IBlogCardProps) => {
    const authorNames = author.join(', ');

    const prefetchBlogPost = usePrefetch('getBlogPostBySlug');

    return (
        <div className="">
            <Link to={`/app/blog/${slug}`} onMouseEnter={() => prefetchBlogPost(slug)}>
                <div className="relative w-full aspect-[calc(16/9)] group">
                    <img src={image?.url} alt={image?.alt_text} className="h-full w-full object-cover rounded-md" />
                    <div className="absolute top-0 w-full h-full bg-blog-neutral-600 opacity-0 transition duration-200 ease-in-out group-hover:opacity-[0.4]"></div>
                </div>
            </Link>

            <div className="mt-4">
                <div className="my-2 font-medium text-blog-neutral-500">
                    <span>{authorNames}</span> • <span>{format(date, 'MMMM d, yyyy')}</span>
                </div>
                <div className="line-clamp-[5]">
                    <p className="font-bold font-museo text-xl my-2 mt-1">{title}</p>
                    <p className="font-inter text-blog-neutral-600">{summary}</p>
                </div>
                <div className="mt-4">
                    <Typography
                        component={Link}
                        to={`/app/blog/${slug}`}
                        className="text-blog-primary-500"
                        onMouseEnter={() => prefetchBlogPost(slug)}
                        target="_blank"
                    >
                        <FormattedMessage id="common.readMore" defaultMessage="Read More" />
                        <ArrowRightAltIcon className="ml-1" />
                    </Typography>
                </div>
            </div>
        </div>
    );
};
